import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { buildCollectionUrl } from '@utils/api/endpoints.paged.ts.tsx';
import { BaseError } from '@utils/types/shared/base';
import { GlossaryList } from '@utils/types/glossary';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export const useGetGlossaries = () => {
  const { searchParams } = useNewAppSearchParams();

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchGlossaries = async () => {
    const base = GET_URL().glossaries!;
    const url = buildCollectionUrl(base, {
      sort: sortField,
      direction: sortDirection,
      q: qString
    });
    const { data } = await Axios.get<GlossaryList>(url);
    return data;
  };

  return useQuery<GlossaryList, AxiosError<BaseError>>(
    ['glossaries', sortField, sortDirection, qString],
    fetchGlossaries,
    {
      useErrorBoundary: false,
      staleTime: 5 * 60 * 1000
    }
  );
};
